export const buildCommonAjaxResourceReducer = (actionLoading, actionLoaded, actionError, payloadToData, adhocActionFunctionMap) => {
  return (state, {type, payload}) => {

    if (typeof actionLoading === 'string') actionLoading = [actionLoading]
    if (typeof actionLoaded === 'string') actionLoaded = [actionLoaded]
    if (typeof actionError === 'string') actionError = [actionError]

    const key = payload ? payload.key : undefined

    const wrappingData = (key, defaultData, clearData = false)=> {
      let data = state ? state : {}

      if (key)
        data[key] = defaultData
      else{
        if(clearData)
          data = defaultData
        else
          data = {...data, ...defaultData}
      }


      return data

    }

    if (state === undefined) {
      state = wrappingData(key, {
        data: [],
        loading: false,
        message: null,
        error: null
      })
    }

    if(adhocActionFunctionMap && adhocActionFunctionMap[type]){
      return adhocActionFunctionMap[type](state, {type, payload})
    }

    if (actionLoaded.includes(type)) {
      if (payloadToData) {

        return wrappingData(key, {
          data: payloadToData(payload),
          loading: false,
          error: null
        })

      } else {

        return wrappingData(key, {
          ...payload,
          loading: false,
          error: null
        })

      }

    }

    if (actionLoading.includes(type)) {

      const data = wrappingData(key, {
        data: [],
        loading: true,
        error: null,
        message: null,
      }, true)

      return data
    }

    if (actionError.includes(type)) {

      return wrappingData(key, {
        data: [],
        loading: false,
        message: null,
        error: op.get(payload, 'xhr.response', payload)
      })
    }

    return state
  }
}

export default buildCommonAjaxResourceReducer



// WEBPACK FOOTER //
// ./src/store/reducerBuilder.js